import { ChannelsNames } from 'modules/application/detail/channels/Channels';
export class FacebookProfileCommandProcessor {
    static $inject = ['MessagingHubService', 'ChannelsService'];
    constructor(MessagingHubService, ChannelsService) {
        'ngInject';
        this.MessagingHubService = MessagingHubService;
        this.ChannelsService = ChannelsService;
    }
    async sendProfileCommand(application, method, profileId, type, resource, address = 'postmaster@messenger.gw.msging.net', channel = ChannelsNames.Messenger, force = false) {
        if (profileId == 'get-started-label') {
            return;
        }
        // Check if the channel is published on messenger
        await this.ChannelsService.init(application);
        const isMessengerActive = this.ChannelsService.isChannelActive(channel);
        if (!isMessengerActive) {
            return;
        }
        if (!force && method == 'set' && profileId == 'persistent-menu') {
            try {
                await this.MessagingHubService.sendCommand({
                    to: address,
                    method: 'get',
                    uri: '/messenger_profile?fields=get_started',
                });
            }
            catch (e) {
                throw new Error(e);
            }
        }
        if (!force && method == 'delete') {
            if (profileId == 'get-started') {
                // Check if there's a persistent_menu in FB
                try {
                    const persistentMenu = await this.MessagingHubService.sendCommand({
                        to: address,
                        method: 'get',
                        uri: '/messenger_profile?fields=persistent_menu',
                    });
                    if (persistentMenu) {
                        // Ignore deleting the get started if there's a persistent menu.
                        return;
                    }
                }
                catch (e) {
                    // In case of error, indicates that there's no persistent menu defined,
                    // so we can continue.
                }
            }
        }
        const command = {
            to: address,
            method: method,
            uri: `/profile/${profileId}`,
        };
        if (method == 'set' && type && resource) {
            command.type = type;
            command.resource = resource;
        }
        await this.MessagingHubService.sendCommand(command);
        if (!force && method == 'delete') {
            if (profileId == 'persistent-menu') {
                // Check if we should delete the get-started from FB
                try {
                    const getStarted = await this.MessagingHubService.sendCommand({
                        method: 'get',
                        uri: '/profile/get-started',
                    });
                    // The get-started exists
                }
                catch (e) {
                    // Delete the get started from FB
                    await this.sendProfileCommand(application, 'delete', 'get-started', type, undefined, address, channel, true);
                }
            }
        }
    }
}
FacebookProfileCommandProcessor.$inject = ['MessagingHubService', 'ChannelsService'];
